<template>
  <div class="dainpu-personal-center g-content">
    <div class="personal-info">
      <img :src="userInfo.iconImg" class="user-header">
      <div class="user-textcontainer">
        <div class="user-name">{{userInfo.nickName|| '爱奇艺知识'}}</div>
        <div class="user-phone">{{userInfo.tel || ' '}}</div>
      </div>
    </div>
    <div class="persion-divider"></div>
    <div style="padding:20px 0 20px 0;">已购课程{{total==0?'':`·${total}`}}</div>

    <div v-if="total>0">
      <div v-for="(item,index) in purchasedList" :key="index">
        <div class="g-single-row-card-item" @click="gotoPage(item)">
          <div style="position: relative;">
            <div class="g-image-landscape-placeholder">
              <div class="g-image-landscape"
                   :style="'background-image:url(' + itemImage(item) + ')'"
              ></div>
            </div>
          </div>
          <div class="g-single-row-card-item-content">
            <div class="g-item-title" v-if="item.contentName">{{item.contentName}}</div>
            <div class="g-item-secondary">
              {{validDuration(item)}}
            </div>
            <div class="lecturetitle-heng-style">
              {{lessonCount(item)}}
            </div>
            <!--                    <div class="minititle-heng-style" v-if="miniTitle">-->
            <!--                       {{miniTitle}}-->
            <!--                    </div>-->

          </div>

        </div>
      </div>
      <div class="bottom-footer">没有更多内容了</div>
    </div>
    <div v-else class="error-layout">
      <img src="../../assets/img/img_none_buy.png" class="error-image">
      <div class="error-title">还没有购买任何课程</div>
      <div class="error-content">学习知识要善于思考，思考，再思考。</div>
      <div class="error-action" @click="goHome">去看看</div>
    </div>

  </div>
</template>

<script>
  import passport from '@iqiyi-kpp/passport'
  import img from '../../assets/img/default-bkg.png'
  import listJson from '../../constants/mock/center'
  import Cookies from 'js-cookie'
  import Api from '@/service/api'
  import utils from '@/utils/util'
  import global from '../../components/Global';
  import pv from '../../service/pingback/pv'

  const defaultNoImg = '../../assets/img/img_defult_tutor.png';

  /**
   * 获取注册制参数
   *
   */
  const getRegisterParam = (subId, dynamic, others) => {
    return {
      biz_id: "14",  //知识付费业务id
      biz_params: {
        biz_dynamic_params: dynamic,//运营动态投放或者基线接口动态组装，比如bookid，h5url的具体值或者参数的组合，以&链接
        biz_extend_params: "", //扩展参数，由各个业务线自己定义，方便以后扩展。接口或者app不做修改
        biz_params: "", //子业务静态参数，一般不变
        biz_statistics: others, //统计相关带入参数
        biz_sub_id: subId, //子业务id，各个垂线业务自己定义
      },
      biz_plugin: "com.iqiyi.knowledge", //业务安卓包名， 只对安卓插件中心有效，从985开始iOS同样改为必运动会参数
    }
  }

  export default {
    data() {
      return {
        headerUrl: defaultNoImg,
        total: 1,
        purchasedList: [],
        userInfo: {},
        defaultImg: 'this.src="' + require('../../assets/img/default-bkg.png') + '"',
        firstTitle: '',
        subTitle: '',
        lectureTitle: '',
        miniTitle: '',
      };
    },
    created() {
      this.$store.dispatch('category/setNvTitle', '知识店铺');
      this.$store.dispatch('category/home', false);
      this.getUserInfo();
      this.getPurchase()
      document.title = '爱奇艺知识';
      const channel = this.$getParameterByName("social_platform")
      if (channel) {
        global.channel = channel;
      }

      let shopTitle = Cookies.get('shopTitle') || ' ';

      // window.pageTitle = shopTitle
      // window.storeInfo = storeInfo

      let opt = {
        rpage: `knowledge_h5_shop_${shopTitle}_我的`,
        v: 1
      }
      pv.send(opt);
    },
    methods: {
      async getUserInfo() {
        const isLogin = await passport.isLogin()
        if (isLogin) {
          let info = await Api.userInfo();
          this.userInfo = info;
        }
      },

      async getPurchase() {
        let qiyiHao = Cookies.get('qiyiId');
        let purchaseData = await Api.purchases(qiyiHao, 0);

        // let purchaseData = listJson.data;
        this.purchasedList = purchaseData && purchaseData.list || [];
        this.total = purchaseData && purchaseData.total || 0;
      },
      validDuration(item) {
        if (item && item.validDuration) {
          if (item.validDuration !== '永久有效') {
            return "剩余有效期：" + item.validDuration;
          } else {
            return item.validDuration;
          }
        }
      },

      lessonCount(item) {
        if (item.curLessonNumbers == item.totalLessonNumbers) {
          return item.totalLessonNumbers + "集全";
        } else {
          return `更新至${item.curLessonNumbers}集 | 共${item.totalLessonNumbers}集`;
        }
      },

      itemImage(item) {
        if (item.image && item.image.appointImageUrl) {
          return item.appointImageUrl;
        } else if (item.image && item.image.sourceImageUrl) {
          return utils.getRightPicSize(item.image.sourceImageUrl);
        } else {
          return ''
        }
      },

      gotoPage(item) {
        let openColumnOrLessonParam = getRegisterParam(7, `id=${item.contentId}&fshop=1`, `channel=${global.channel}`);
        let bizParamStr = JSON.stringify(openColumnOrLessonParam);
        let schema = this.$getUrlParamsArr('scheme').pop();

        if (browser.knowledge) {
          location.href = `knowledge://mobile/register_business/com_iqiyi_knowledge?pluginParams=` + encodeURIComponent(encodeURIComponent(bizParamStr));
        } else if (browser.iqiyi) {
          location.href = 'iqiyi://mobile/register_business/com_iqiyi_knowledge?pluginParams=' + encodeURIComponent(encodeURIComponent(bizParamStr));
        } else {
          location.href = `http://zhishi.m.iqiyi.com/column?columnId=${item.contentId}&channel=${global.channel}`;
        }
      },

      goHome() {
        if (Cookies.get('homePageUrl')) {
          window.location.href = Cookies.get('homePageUrl');
        }
      }
    },
    computed: {},
  }
</script>

<style lang="less" scoped>
  @import "../../assets/css/func.less";
  @import "../../assets/css/var.less";

  .dainpu-personal-center {
    color: #1F1F1F;
    .set(font-size, 34);
  }

  .personal-info {
    display: flex;
    background: white;
    justify-content: flex-start;
    align-items: center;
    .set(height, 180);
    box-sizing: border-box;
  }

  .user-header {
    border-radius: 50%;
    object-fit: cover;
    background: #eaeaea;
    .set(width, 98);
    .set(height, 98);
  }

  .user-textcontainer {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 10px;
    .set(height, 80);
  }

  .user-name {
    color: #1F1F1F;
    font-weight: 500;
    font-size: 15px;
    line-height: 21px;
    height: 21px;
  }

  .user-phone {
    color: #999999;
    font-size: 11px;
    line-height: 15px;
    height: 15px;
  }

  .persion-divider {
    background: #f8f8f8;
    height: 5px;
    width: 100%;
  }

  .lecturetitle-heng-style {
    .set(font-size, 24);
    .set(line-height, 24);
    .set(height, 24);
    color: #888888;
    .set(margin-bottom, 24);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .minititle-heng-style {
    .set(font-size, 24);
    .set(line-height, 24);
    .set(height, 24);
    color: #333333;
    display: flex;
    flex-direction: row;
    white-space: pre;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
